import React from "react";

function classify(qKey, dataGroup, variableTypes) {
  const q = dataGroup[qKey];
  const names = (q?.varName || []).map((v) => v.Name).filter(Boolean);
  if (!names.length) return null;
  let role = "categorical";
  if (variableTypes) {
    role = names.every((n) => variableTypes.numeric?.includes(n)) ? "numeric" : "categorical";
  } else {
    const t = (q?.type || "").toLowerCase();
    role = t === "numeric" || t.includes("numeric") ? "numeric" : "categorical";
  }
  return { key: qKey, role, names, single: names.length === 1, label: q?.Qtitle || qKey };
}

/**
 * Shows whatever the user has picked via the app's own left Sidebar
 * (VariableContext.currentSelectedVariables) and lets them click an entry to
 * assign/unassign it into the currently active role zone. Browsing/searching
 * happens in the Sidebar itself — this panel is just the assignable pool.
 */
function SelectedVariablesPool({ dataGroup, variableTypes, selectedKeys, activeZone, assignedKeys, onToggle, onClear }) {
  const assigned = new Set(assignedKeys || []);
  const rows = (selectedKeys || [])
    .map((key) => classify(key, dataGroup, variableTypes))
    .filter(Boolean);

  return (
    <div className="dv-panel">
      <div className="dv-panel-header">
        <h4>Selected Variables</h4>
        <span className="dv-count">{rows.length} from sidebar</span>
      </div>

      {activeZone && (
        <div className="dv-active-zone-hint">
          Assigning to: <strong>{activeZone.label}</strong>
          {activeZone.role !== "any" && ` (${activeZone.role} only)`}
        </div>
      )}

      {rows.length === 0 ? (
        <p className="analysis-muted">
          Nothing selected yet — click questions in the left sidebar to add them here.
        </p>
      ) : (
        <div className="dv-list">
          {rows.map((r) => {
            const isAssigned = assigned.has(r.key);
            const compatible = !activeZone || activeZone.role === "any" || activeZone.role === r.role;
            const requiresSingle = activeZone && !activeZone.multiple && !r.single;
            const clickable = !!activeZone && compatible && !requiresSingle;
            return (
              <div
                key={r.key}
                className={`dv-row ${isAssigned ? "assigned" : ""} ${clickable ? "clickable" : "disabled"}`}
                onClick={() => clickable && onToggle(r.key)}
                title={requiresSingle ? "This role needs a single-variable question" : undefined}
              >
                <span className={`dv-badge dv-badge-${r.role}`}>{r.role === "numeric" ? "N" : "C"}</span>
                <span className="dv-info">
                  <span className="dv-label">{r.label}</span>
                  <span className="dv-code">{r.key}</span>
                </span>
                <span className={`dv-indicator ${isAssigned ? "check" : "plus"}`}>
                  {isAssigned ? "✓" : clickable ? "+" : ""}
                </span>
              </div>
            );
          })}
        </div>
      )}

      {rows.length > 0 && (
        <button className="dv-clear-btn" onClick={onClear}>Clear Variable List</button>
      )}
    </div>
  );
}

export default SelectedVariablesPool;
